// Zone-specific status badges. The accountability label builders + chain mappers
// (chainLabels / coverageLabels / coverageOf / toAssignmentItems / …) are shared
// across every scope entity — see components/patterns/accountabilityDisplay.ts.

import type { TFunction } from 'i18next';
import { Badge } from '../../../components/ui/Badge.js';

// ── status / default badges ───────────────────────────────────────────────────
export function ZoneStatusBadge({ disabled, t }: { disabled: boolean; t: TFunction }) {
  return (
    <Badge variant={disabled ? 'neutral' : 'success'} appearance="subtle">
      {disabled ? t('status.disabled') : t('status.active')}
    </Badge>
  );
}

// Status pill + a Default chip only when the zone is the default (the header /
// peek / list-name group).
export function ZoneStatusGroup({
  isDisabled,
  isDefault,
  t,
}: {
  isDisabled: boolean;
  isDefault: boolean;
  t: TFunction;
}) {
  return (
    <span className="inline-flex items-center gap-2">
      <ZoneStatusBadge disabled={isDisabled} t={t} />
      {isDefault && (
        <Badge variant="brand" appearance="subtle">
          {t('default')}
        </Badge>
      )}
    </span>
  );
}
